import { Mail, HelpCircle, Megaphone, CalendarDays } from "lucide-react";

export const COMM_TYPE_FILTERS = [["", "All"], ["email", "Emails"], ["rfi", "RFIs"], ["site_instruction", "Instructions"], ["meeting", "Meetings"]];
const types = { email: ["Email", Mail], rfi: ["RFI", HelpCircle], site_instruction: ["Instruction", Megaphone], meeting: ["Meeting", CalendarDays], general: ["General", Mail] };
export const jobCommsPath = (id) => `/app/jobs/${encodeURIComponent(id)}/communications`;
export function commDate(value) {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleString("en-NZ", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
export function CommunicationType({ type }) {
  const [label, Icon] = types[type] || types.general;
  return <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wide text-zinc-600 dark:text-zinc-300"><Icon className="w-3.5 h-3.5 shrink-0" />{label}</span>;
}
export function CommunicationStatus({ status }) {
  const review = status === "quarantined";
  return <span className={`inline-flex rounded px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${review ? "bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300" : "bg-zinc-100 text-zinc-600 dark:bg-white/10 dark:text-zinc-300"}`}>{review ? "Needs review" : status === "stored" ? "Stored" : (status || "").replaceAll("_", " ")}</span>;
}
